import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-data" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "list-actions" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "empty"
}
const _hoisted_8 = { class: "actions" }

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  translationList,
  translationAdd,
  translationPatch,
  translationDel,
} from "@/common/api/rest/translation";

import type {
  TranslationType,
  TranslationFieldsType,
} from "@/common/types/translation";

import { FormTranslate } from "@/components";
import { baseConfirm, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'list-translate',
  props: {
    ownerId: {},
    language: {},
    fields: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const selected = ref<TranslationType | null>(null);
const list = ref<TranslationType[]>([]);

const showModalAdd = ref(false);
const showModalDel = ref(false);

function fetchData() {
  if (!props.ownerId) return;

  translationList(props.ownerId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        list.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
}

function addItemConfirm() {
  translationAdd(props.ownerId, {
    language: props.language,
    metadata: null,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        addItemCancel();
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delItem(data: TranslationType) {
  showModalDel.value = true;
  selected.value = data;
}

function delItemCancel() {
  showModalDel.value = false;
  selected.value = null;
}

function delItemConfirm() {
  translationDel(selected.value?.translation_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        delItemCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchItem(translation_id: string, payload: Partial<TranslationType>) {
  translationPatch(translation_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("translate.labels.translations")), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.translation_id
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-danger px-3 py-2",
              onClick: ($event: any) => (delItem(item))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "trash",
                size: "1.25rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.delete")), 1)
            ], 8, _hoisted_6)
          ]),
          _createVNode(_unref(FormTranslate), {
            fields: props.fields,
            data: item,
            language: props.language,
            "onUpdate:data": ($event: any) => (patchItem(item.translation_id, $event))
          }, null, 8, ["fields", "data", "language", "onUpdate:data"]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1))
        ], 64))
      }), 128)),
      ((list.value || []).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)("translate.texts.empty")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-md btn-default uppercase px-4",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem()))
        }, _toDisplayString(_unref(t)("translate.labels.add_translate")), 1)
      ])
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalAdd.value,
      title: _unref(t)('translate.labels.add_translate').toUpperCase(),
      message: _unref(t)('translate.texts.add_translate'),
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addItemConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('translate.labels.delete_translate').toUpperCase(),
      message: _unref(t)('translate.texts.delete_translate'),
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (delItemCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (delItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})